import { CompsUI } from "app/NativeComponents/snippets";
import React, { Component } from "react";
import { Wrapper, Row, Title, Copy } from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";

import {
  checkIfUserHasBillingAddon,
  getBillingAddonId,
  renderPrice
} from "app/NativeActions";

class Comps extends Component {
  constructor(props) {
    super(props);

    this.handlePurchasePress = this.handlePurchasePress.bind(this);
    this.handleModalPress = this.handleModalPress.bind(this);
  }

  handleModalPress(addon) {
    this.props.updateBillingAddon({
      token: this.props.token,
      type: "purchase",
      slug: addon.slug,
      addon_id: addon.id
    });
  }
  handlePurchasePress() {
    const { card_info, billing_addons } = this.props;

    if (card_info.has_card) {
      const addon = billing_addons.find(item => item.slug === "comps");

      if (addon) {
        this.props.setModal({
          title: "Purchase add-on",
          description:
            "Are you sure you want to purchase this add-on? You will receive a pro-rated charge today. On your next billing cycle you will be charged " +
            renderPrice(addon.monthly_price) +
            ".",
          icon: "check",
          submit: "Confirm Purchase",
          onPress: () => this.handleModalPress(addon),
          cancel: "Not right now"
        });
        this.props.toggleModal({ show: true, type: "normal" });
      }
    } else {
      this.props.appRedirect({ redirect: "cardOnFile" });
    }
  }

  render() {
    const { property, billing_addons, platform } = this.props;
    if (
      !checkIfUserHasBillingAddon({
        billing_addons: billing_addons,
        slug: "comps"
      })
    ) {
      if (platform == "ios") {
        return (
          <Wrapper style={{ padding: 20 }}>
            <Title style={{ textAlign: "center", marginBottom: 10 }}>
              We're here for you.
            </Title>
            <Copy style={{ textAlign: "center" }}>
              You cannot add our comps tool in the app. Check out DealMachine on
              the web to enable this feature.
            </Copy>
          </Wrapper>
        );
      }

      return (
        <Wrapper style={{ padding: 20 }}>
          <OnboardingText
            slug="compsAddon"
            style={{
              padding: 0
            }}
            innerStyle={{
              padding: 20
            }}
            center={true}
          />
          <Row style={{ justifyContent: "center" }}>
            <PillButton
              style={{ marginLeft: 0 }}
              primary={true}
              onPress={this.handlePurchasePress}
            >
              Purchase Add-on
            </PillButton>
          </Row>
        </Wrapper>
      );
    }

    return <CompsUI property={property} />;
  }
}

export default Comps;
